import React from 'react';
import { Flex } from '@banhala/ui-kit';
import { PiecesInfo } from './components/PiecesInfo';
import { DefaultInformation } from './components/DefaultInformation';
import { PIPNInfo } from './components/PIPNInfo';
import { SellerInfo } from './components/SellerInfo';
import { ModelInfo } from './components/ModelInfo';
import { WashingGuide } from './components/WashingGuide';

interface ProductInfoProps {
  hideOnEmpty?: boolean;
  fromTab?: boolean;
}

export const ProductInfo: React.FC<ProductInfoProps> = ({
  hideOnEmpty,
  fromTab,
}) => {
  return (
    <Flex>
      <PiecesInfo hideOnEmpty={hideOnEmpty} />
      <DefaultInformation />
      {!fromTab && <PIPNInfo />}
      {!fromTab && <SellerInfo />}
      {!fromTab && <ModelInfo />}
      {!fromTab && <WashingGuide />}
    </Flex>
  );
};
